import * as React from 'react';
import Text from 'components/Text';
import Tooltip from 'components/Tooltip';
import TooltipTrigger from 'components/TooltipTrigger';

import './styles/TextWithTooltip.scss';

/**
 * ## Add a [Tooltip](/internal/components/Tooltip) to inline [Text](/internal/components/Text).
 *
 *
 * ```example
 * <Text>
 *   Lorem
 *   {' '}
 *   <TextWithTooltip tooltip="Total number of announcements and chats">
 *     ipsum dolor
 *   </TextWithTooltip>
 *   {' '}
 *   sit amet.
 * </Text>
 * ```
 */

type Props = {
  children?: React.ReactChildren;
  tooltip: string;
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left';
};

const TextWithTooltip = (props: Props) => {
  const { children, tooltip, tooltipPlacement = 'top', ...others } = props;

  return (
    <TooltipTrigger placement={tooltipPlacement} tooltip={<Tooltip>{tooltip}</Tooltip>}>
      <span>
        <Text {...others} decoration="dashes">
          {children}
        </Text>
      </span>
    </TooltipTrigger>
  );
};

export default TextWithTooltip;
